import { all, takeLatest, put, call } from 'redux-saga/effects';

import { AxiosResponse } from 'axios';

import api from 'services/api';
import { downloadFileFromBase64 } from 'utils/downloadFile';

import {
  downloadFileRequest,
  downloadFileRequestActions,
  downloadFileSuccess,
  downloadFileFailure,
} from './actions';

import { IDownloadFileTypes } from './types';

type IDownloadFileType = ReturnType<typeof downloadFileRequest>;

export function* downloadFile({ payload }: IDownloadFileType) {
  try {
    const { requestNumber, fileName, fileType, actionNumber } = payload;

    const formData = new FormData();
    formData.append('chamado', requestNumber);
    formData.append('nomeArquivo', fileName);
    formData.append('tipoAnexo', fileType);
    formData.append('numeroAcao', actionNumber);

    const { data }: AxiosResponse = yield call(
      api.post,
      '/portal-conecta/download-anexo-chamados',
      formData,
    );

    yield call(downloadFileFromBase64, {
      encodedFile: data.response.returnData,
      fileName,
      mimeType: 'application/octet-stream',
    });

    yield put(downloadFileSuccess());
  } catch (err) {
    if (err && err?.response) {
      const response = {
        status: err.response?.status,
        message: err.response?.data.message,
      };

      yield put(downloadFileFailure(response));
    }
  }
}

type IDownloadFileActionType = ReturnType<typeof downloadFileRequestActions>;

export function* downloadFileActions({ payload }: IDownloadFileActionType) {
  try {
    const { requestNumber, fileType, attachmentActions } = payload;

    const formData = new FormData();
    formData.append('nomeArquivo', attachmentActions);
    formData.append('tipoAnexo', fileType);
    formData.append('chamado', requestNumber);

    const { data }: AxiosResponse = yield call(
      api.post,
      '/portal-conecta/download-anexo-chamados',
      formData,
    );

    yield call(downloadFileFromBase64, {
      encodedFile: data.response.returnData,
      fileName: attachmentActions,
      mimeType: 'application/octet-stream',
    });

    yield put(downloadFileSuccess());
  } catch (err) {
    if (err && err?.response) {
      const response = {
        status: err.response?.status,
        message: err.response?.data.message,
      };

      yield put(downloadFileFailure(response));
    }
  }
}

export default all([
  takeLatest(IDownloadFileTypes.DOWNLOAD_FILE_REQUEST, downloadFile),
  takeLatest(
    IDownloadFileTypes.DOWNLOAD_FILE_REQUEST_ACTIONS,
    downloadFileActions,
  ),
]);
